import {EventBus} from '@/event-bus.js';
import DEFINES from '@/defines';
import i18n from '@/i18n';
import {getField, updateField} from 'vuex-map-fields';

function initialState() {
  return {
    app: {
      layout: 'LAYOUT_AUTH',
    },
    toolbar: {
      title: 'toolbar',
      drawer: false,
    },
    notifications: [],
    session_locked: false,
    referrer: null,
    context_menus: [],
    unread_messages_count: 0,
    i18n_locale: i18n.locale,
    ThemeTheory: null,
  };
}

const state = initialState();

// actions

const actions = {
  showMessage: (context, payload) => {
    EventBus.$emit('showMessage', payload);
  },

  showErrorMessageDialog: (context, payload) => {
    EventBus.$emit('showReminderMessageDialog', payload);
  },

  hideErrorMessageDialog: (context, payload) => {
    EventBus.$emit('hideReminderMessageDialog');
  },

  async setAppLayout(context, payload) {
    await context.commit('set_app_layout', payload);
    console.log(context.getters['appLayout'], context.state.app.layout);
  },

  showLoader(context) {
    EventBus.$emit('showLoader');
  },

  hideLoader(context) {
    EventBus.$emit('hideLoader');
  },

  updateLocale(context, payload) {
    context.commit('set_locale', payload);
  },

  toggleTheme({ commit, state },payload) {
    commit('SET_THEME', payload);
  },
};

// getters
const getters = {
  getField,
  /** is user logged in */
  isLoggedIn: (state, getters, rootState) => {
    return rootState.auth.key && rootState.auth.secret;
  },
  appLayout: (state) => state.app.layout,

  getMenu: (state) => state.context_menus,
};

// mutations
const mutations = {
  updateField,
  set_app_layout(state, payload) {
    // console.log('old layout:', state.app.layout);
    state.app.layout = payload.layout;
    // console.log('new layout:', state.app.layout);
  },

  set_drawer(state, payload) {
    state.toolbar.drawer = payload.value;
  },

  set_is_addmin_panel(state, payload) {
    state.is_admin_panel = payload.is_admin_panel;
  },

  set_locale(state, payload) {
    // Change locale for user
    i18n.locale = payload.locale;
    // Change global locale (app's locale)
    state.i18n_locale = i18n.locale;
  },

  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
  SET_THEME(state, value) {
    state.ThemeTheory = value;
    localStorage.setItem('MEW_CURRENT_THEME_THEORY', JSON.stringify(value));
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
